// @flow

import React from 'react';

import type {Node} from 'react';

type Props = {
  tabSelected: number,
  tab: number | string,
  children: Node,
};

function TabWrapperComponent({tabSelected, tab, children}: Props) {
  const showTab = tabSelected === tab;
  return (
    <div
      style={{
        display: showTab ? undefined : 'none',
      }}
    >
      {children}
    </div>
  );
}

const TabWrapper = React.memo(TabWrapperComponent);

export default TabWrapper;
